import React from 'react';
import { motion } from 'framer-motion';
import { Package, ChevronUp } from 'lucide-react';
import { useBox } from '../context/BoxContext';
import { Button } from './ui/button';
import { Progress } from './ui/progress';

export const MobileBottomBar = ({ onViewBox, onCheckout }) => {
  const { selectedProducts, boxSize, isFull, progress, getCurrentBoxInfo } = useBox();
  const boxInfo = getCurrentBoxInfo();

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="mobile-bottom-bar lg:hidden"
      data-testid="mobile-bottom-bar"
    >
      <div className="flex items-center gap-3">
        {/* Box Preview */}
        <button
          onClick={onViewBox}
          className="flex items-center gap-2 bg-gray-50 rounded-xl px-3 py-2 flex-shrink-0"
          data-testid="mobile-view-box-btn"
        >
          <div className="relative">
            <Package className="w-6 h-6 text-[#0FA49C]" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#0FA49C] text-white text-[10px] font-bold rounded-full flex items-center justify-center">
              {selectedProducts.length}
            </span>
          </div>
          <ChevronUp className="w-4 h-4 text-gray-400" />
        </button>

        {/* Progress & Checkout */}
        <div className="flex-1">
          <div className="flex justify-between text-xs mb-1">
            <span className="text-[#666] font-medium">{boxInfo.name}</span>
            <span className="font-bold text-[#0FA49C]">£{boxInfo.price.toFixed(2)}</span>
          </div>
          <Progress value={progress} className="h-1.5 mb-2" />
          <Button
            className="w-full bg-[#0FA49C] text-white hover:bg-[#0d8f88] rounded-xl py-2 text-sm font-bold"
            disabled={!isFull}
            onClick={onCheckout}
            data-testid="mobile-checkout-btn"
          >
            {isFull ? 'Complete Box' : `Add ${boxSize - selectedProducts.length} more`}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
